import { connect } from 'react-redux';
import { push } from 'react-router-redux/lib/actions';
import Component from './component';
import managerCRUDActions from '../../../actions/manager';
import {getManagersConfig} from '../managersConfig';
import {getCurrentClubId} from '../../../selectors/club-settings';

export default connect(
  (state) => {
    const currentClubId = getCurrentClubId(state)
    return {
      ...getManagersConfig(currentClubId),
      isNew: false,
      title: 'Edit Manager',
      loading: state.manager.loadingItem,
      model: state.manager.model,
      initialValues: prepareInitialValues(state.manager.model)
    }
  },
  (dispatch) => ({
    fetch: (id) => dispatch(managerCRUDActions.fetch(id)),
    goIndex: () => dispatch(push('/managers'))
  })
)(Component);

function prepareInitialValues(data) {
  if (data) {
    let {role, first_name, last_name, email, password, club} = data;

    return Object.assign({role, first_name, last_name, email, password}, {
      club_id: club.id
    })
  } else {
    return {};
  }

}




// WEBPACK FOOTER //
// ./src/components/Managers/ManagersEdit/index.js